// extracted by mini-css-extract-plugin
module.exports = {"button":"media-browser_button__zZwMM","container":"media-browser_container__2lwXM"};